/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsCreateSupplier
 */
export interface ControlcenterMelcoModelsCreateSupplier {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCreateSupplier
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCreateSupplier
     */
    supplier_type?: string | null;
}

export function ControlcenterMelcoModelsCreateSupplierFromJSON(json: any): ControlcenterMelcoModelsCreateSupplier {
    return ControlcenterMelcoModelsCreateSupplierFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsCreateSupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsCreateSupplier {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'supplier_type': !exists(json, 'supplier_type') ? undefined : json['supplier_type'],
    };
}

export function ControlcenterMelcoModelsCreateSupplierToJSON(value?: ControlcenterMelcoModelsCreateSupplier | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'supplier_type': value.supplier_type,
    };
}


